module.exports = __webpack_public_path__ + "static/media/bell-school-slash.aece36b5.svg";